import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ckb',
    fullName: 'Central Kurdish',
    nativeName: 'کوردیی ناوەندی',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ئارگڤۆید",
    landing_title: "شتێکی سەرسوڕهێنەر لە ئارادایە",
    landing_subtitle: "ArgVoid ستۆدیۆیەکی پەرەپێدانی ئەپ و یارییەکانە. چاوەڕوان بن، بەم زووانە شتی نوێ دێن!",
    select_language: "زمان هەڵبژێرە",
    search_placeholder: "گەڕان بە زمانەکان...",
    terms_title: "مەرجەکانی خزمەتگوزاری",
    policy_title: "سیاسەتی پاراستنی نهێنی",
    cookies_title: "سیاسەتی کووکی",
    terms_content: `
        <strong>1. قبوڵکردنی مەرجەکان</strong><br>
        بە چوونە ناو ArgVoid، ئەم مەرجانەی خزمەتگوزاری وەرگیراون. ئەگەر ئەم مەرجانە لەسەری ڕێکنەکەوتن، نابێت خزمەتگوزارییەکە بەکاربهێنرێت.<br><br>

        <strong>2. بەکارهێنانی پلاتفۆرم</strong><br>
        ArgVoid و بەرنامەکانی "وەک خۆیان" بۆ مەبەستی زانیاری و داهێنەرانە دابین دەکرێن. خزمەتگوزارییەکە دەبێت تەنها بۆ مەبەستی یاسایی بەکاربهێنرێت.<br><br>

        <strong>3. ڕەفتاری قەدەغەکراو</strong><br>
        ئیستغلالکردنی لاوازییەکانی ماڵپەڕ، سپامکردن، یان هەوڵدان بۆ دەستگەیشتن بە ژێرخانی بێ مۆڵەت بە توندی قەدەغەیە.<br><br>

        <strong>4. ڕەتکردنەوەی بەرپرسیاریەتی</strong><br>
        دەتوانرێت لە هەر کاتێکدا بەبێ ئاگادارکردنەوە دەستکاری پلاتفۆرم و خزمەتگوزارییەکان بکرێت. هیچ گەرەنتییەک سەبارەت بە کاتی کارکردن یان بەردەستبوونی خزمەتگوزارییەکە دابین نەکراوە.
    `,
    policy_content: `
        <strong>1. کۆکردنەوەی زانیاری</strong><br>
        پلاتفۆرمەکە لە ئێستادا پێویستی بە ڕەسەنایەتی بەکارهێنەر یان دروستکردنی ئەکاونت نییە. هیچ زانیارییەکی ناسینەوەی کەسی (وەک ناو یان ناونیشانی ئیمەیڵ) بە شێوەیەکی چالاکانە لە سەردانکەران کۆناکرێتەوە.<br><br>

        <strong>2. بەکارهێنان Data</strong><br>
        ڕەنگە شیکارییە بنەڕەتی و بێناوەکان کۆبکرێنەوە بۆ تێگەیشتن لە هاتوچۆی ماڵپەڕەکان و باشترکردنی بەرنامەکان. ئەم داتایانە بەستراوەتەوە بە ناسنامەی تاکەکەسی بەکارهێنەر.<br><br>

        <strong>3. خزمەتگوزاری لایەنی سێیەم</strong><br>
        لەوانەیە دابینکەرانی لایەنی سێیەم بۆ خزمەتگوزارییەکانی هۆستکردن و شیکاری بەکاربهێنرێن. پراکتیکەکانی پاراستنی نهێنی ئەم دابینکەرانە ئەو زانیارییە نادیارانە بەڕێوەدەبەن کە لەسەر ژێرخانی خۆیان پرۆسێس دەکرێن.<br><br>

        <strong>4. ئاسایشی داتا</strong><br>
        بۆ پاراستنی پلاتفۆرمەکە ڕێوشوێنی ئەمنی گونجاو جێبەجێ دەکرێت. بەڵام هیچ شێوازێکی گواستنەوە لە ڕێگەی ئینتەرنێتەوە بە تەواوی پارێزراو نییە.<br><br>
    `,
    cookies_content: `
        <strong>1. کووکی و هەڵگرتنی ناوخۆیی چییە؟</strong><br>
        کووکی و هەڵگرتنی ناوخۆیی وێبگەڕ فایلە بچووکەکانی داتان کە لەسەر ئامێرەکە هەڵدەگیرێن بۆ ئەوەی هەڵبژاردەکانی ڕێکخستن لە سەرانسەری سەردانەکاندا لەبیرت بێت.<br><br>

        <strong>2. مەبەستی بەکارهێنان</strong><br>
        وێبگەڕ LocalStorage بە توندی بەکاردێت بۆ پاشەکەوتکردنی ڕێکخستنەکانی ڕێکخستن، وەک:<br>
        - هەڵبژاردنی زمان<br>
        - ڕێکخستنی ڕووکاری بەکارهێنەر (بۆ نموونە، ڕێکخستنەکانی نەخشە یان تەوەر)<br>
        - cache ی بەرنامەی کاتی<br><br>

        <strong>3. بێ شوێنپێهەڵگرتن</strong><br>
        کووکی و هەڵگرتنی ناوخۆیی بۆ مەبەستی ڕێکلام یان بەدواداچوونی لایەنی سێیەم بەکارناهێنرێت. هەموو داتا هەڵگیراوەکان بە توندی بۆ کارایی سەرەکی پلاتفۆرمەکەن.<br><br>

        <strong>4. کۆنتڕۆڵ</strong><br>
        دەتوانرێت داتاکانی وێبگەڕ لە هەر کاتێکدا لە ڕێگەی ڕێکخستنەکانی وێبگەڕەوە پاک بکرێتەوە، کە هەر ڕێکخستنێکی ناوخۆیی ڕێست دەکاتەوە.
    `,
    cookie_consent_text: "ئێمە کووکی بنەڕەتی بەکاردەهێنین بۆ دڵنیابوون لە کارکردنی ماڵپەڕەکە بە دروستی، وەک چالاک هێشتنەوەی دانیشتنەکەت، پاشەکەوتکردنی هەڵبژاردەی زمانەکەت و ڕێکخستنە تایبەتەکانی تر.",
    read_policy: "سیاسەتی کووکی بخوێنەرەوە",
    support_title: "پەیوەندی بە پشتگیرییەوە بکە",
    support_subject_label: "بابەت",
    support_message_label: "پەیام",
    support_submit_button: "نامە بنێرە",
    support_hint: "تێبینی: بەم شێوەیە بەرنامەی ئیمەیڵی پێشوەختەتان دەکاتەوە بۆ ناردنی نامەکە.",
    support_success_msg: "کردنەوەی ئەپی ئیمەیڵەکەت...",
    support_error_msg: "شکستی هێنا لە ناردنی نامە. تکایە دواتر هەوڵبدەرەوە.",
    explorer_title: "ئێکسپلۆرەر",
    history_title: "مێژوو",
    animation_title: "ئەنیمەیشن",
    config_title: "ڕێکخستن",
    tool_mouse: "(Ctrl+M) هەڵبژێرە",
    tool_brush: "فڵچە (Ctrl+B)",
    tool_brush_mode: "دۆخی گۆڕین (ڕەق/ڕوون)",
    tool_eraser: "سڕکەر (Ctrl+E)",
    tool_brush_size: "قەبارەی فڵچە ڕێکبخە",
    tool_bucket: "پڕبکەرەوە (Ctrl+F)",
    tool_eyedropper: "دڵۆپی چاو",
    tool_grid: "تۆڕ (Ctrl+Shift+B)",
    tool_rotate: "سوڕانەوە (Ctrl+Shift+R)",
    tool_flip_h: "فلیپ H (Ctrl+Shift+H)",
    tool_flip_v: "فلیپ V (Ctrl+Shift+V)",
    tool_transpose: "گواستنەوە (Ctrl+Shift+T)",
    label_width: "پانی",
    label_height: "بەرزی",
    label_frames: "ژمارەی چوارچێوەکان",
    label_animation: "شێوازی ئەنیمەیشن",
    label_background_color: "ڕەنگی پاشبنەما",
    label_interval: "ئینتەرڤاڵ",
    tool_anim_config: "ڕێکخستنی ئەنیمەیشن",
    label_new_width: "پانایی نوێ",
    label_new_height: "بەرزی نوێ",
    label_apply: "جێبەجێکردن",
    label_colors: "ڕەنگەکان",
    label_size: "قەبارە",
    label_tolerance: "لێبووردەیی",
    val_horizontal: "ئاسۆیی",
    val_vertical: "ستوونی",
    val_sequence: "زنجیرە",
    val_bounce: "هەڵبەزین",
    val_random: "دەگمەن",
    val_solid: "ڕەق",
    val_clear: "ڕوون",
    action_add_sheet: "لاپەڕەی نوێ",
    action_import: "هاوردەکردن",
    action_export: "هەناردە",
    action_sort_projects: "جۆر",
    sort_date_old: "کۆنترین یەکەم",
    sort_date_new: "نوێترین یەکەم",
    sort_name_az: "ناوی (A-Z)",
    sort_name_za: "ناوی (Z-A)",
    action_new_sprite: "نیو سپرایت",
    action_new_project: "پڕۆژەی نوێ",
    modal_save_all_title: "هەموو گۆڕانکارییەکان پاشەکەوت بکە",
    modal_save_all_desc: "ئەو سەروەت و سامانانە هەڵبژێرە کە بۆ پاشەکەوتکردن:",
    modal_save_selected: "پاشەکەوتکردن هەڵبژێردراوە",
    action_saved: "پاشەکەوت کراوە",
    modal_create_sprite_title: "دروستکردنی سپرایتێکی نوێ",
    modal_create_project_title: "دروستکردنی پرۆژەی نوێ",
    modal_add_sheet_title: "زیادکردنی لاپەڕەی نوێ",
    modal_rename_sheet_title: "گۆڕینی ناوی Sheet",
    modal_rename_sprite_title: "ناوی Sprite بگۆڕە",
    modal_delete_sprite_title: "سڕینەوەی سپرایت",
    modal_delete_project_title: "پرۆژەی سڕینەوە",
    modal_delete_sheet_title: "سڕینەوەی لاپەڕە",
    placeholder_sprite_name: "ناو",
    placeholder_project_name: "ناو",
    placeholder_sheet_name: "ناو",
    placeholder_new_name: "ناوی نوێ",
    action_create: "دروستکردن",
    action_add: "زیادکردن",
    action_rename: "ناوی بگۆڕە",
    action_duplicate: "دووبارەکردنەوە",
    action_delete: "سڕینەوە",
    action_cancel: "ڕەتکردنەوە",
    confirm_delete_sprite: "ئایا دڵنیای کە دەتەوێت ئەم سپرایتە بسڕیتەوە؟",
    confirm_delete_project: "دڵنیای کە دەتەوێت ئەم پڕۆژەیە بسڕیتەوە؟ هەموو سپرایتەکان لا دەبرێن.",
    confirm_delete_sheet: "ئایا دڵنیای کە دەتەوێت ئەم لاپەڕەیە بسڕیتەوە؟",
    err_select_sprite: "تکایە سەرەتا سپرایتێک هەڵبژێرە.",
    err_select_project: "تکایە سەرەتا پرۆژەیەک هەڵبژێرە.",
    err_name_empty: "ناو ناتوانرێت بەتاڵ بێت.",
    err_sprite_exists: "سپرایتێک بەو ناوەوە پێشتر بوونی هەیە.",
    err_project_exists: "پڕۆژەیەک بەو ناوەوە پێشتر بوونی هەیە.",
    err_no_content: "هیچ ناوەڕۆکێک نییە بۆ پاشەکەوتکردن.",
    err_no_changes: "هیچ گۆڕانکارییەک بۆ پاشەکەوتکردن نییە.",
    err_delete_last_sheet: "ناتوانرێت دوا لاپەڕە بسڕدرێتەوە.",
    err_extract_frames: "نەیتوانی هیچ چوارچێوەیەک دەربهێنێت.",
    err_indexeddb: "شکستی هێنا لە پاشەکەوتکردنی ناوخۆیی. لەوانەیە وێبگەڕەکەت پشتگیری لە IndexedDB نەکات.",
    msg_upload_success: "بارکردن سەرکەوتوو بوو: {0}",
    msg_upload_failed: "بارکردن شکستی هێنا: {0}",
    msg_save_success: "سەیڤ سەرکەوتووە.",
    msg_saving: "پاشەکەوتکردنی...",
    msg_multi_save_result: "{0} سەروەت و سامان پاشەکەوت کراوە. {1} شکستەکان.",
    menu_title: "مێنۆ",
    menu_save: "هەڵگرتن",
    menu_save_all: "هەمووان ڕزگار بکە",
    menu_support: "پەیوەندی بە پشتگیرییەوە بکە",
    label_local_storage: "هەڵگرتنی ناوخۆیی",
    label_sign_in: "چوونەژوورەوە",
    modal_export_title: "هەناردەکردنی سپرایت",
    label_filename: "ناوی پەڕگە",
    label_format: "فۆرمات",
    action_export_confirm: "هەناردە",
};

export default translations;
